/**
 * Created by Cheng on 14-7-4.
 */
let Backbone = require("backbone");
let PagingView = require("../comp/PagingView.js");
let PagingModel = require("../../model/PagingModel.js");

let main = function (Backbone, PagingView, PagingModel) {
    return Backbone.View.extend({
        initialize: function () {
            var viewHeight = $(window).height() - 280 - this.$('.nav-tabs').height();
            this.pagingModel = new PagingModel({viewHeight: viewHeight, rowSize: 1, rowHeight: 62, itemSize: this.$('ul.list-group .list-group-item:not(.template)').size()});
            this.pagingView = new PagingView({el: this.$('ul.list-group'), pagingControl: this.$('.paging'),
                model: this.pagingModel
            });

        },

        render: function () {
            this.pagingModel.setItemSize(this.$('ul.list-group .list-group-item:not(.template)').size());
            this.pagingView.render();
            return this;
        },

        toLastPage: function(){
            this.pagingView.toLastPage();
        }
    });
};

let exportedValue = main(Backbone, PagingView, PagingModel);
module.exports = exportedValue;



// WEBPACK FOOTER //
// ./src/view/settings/BillNotesView.js